import { DATE_YEAR_MM_DD } from 'constants/dateFormat';
import { format } from 'date-fns';

export const formatDateForURL = (date: Date): string =>
  format(date, DATE_YEAR_MM_DD);
